import { useState, useEffect } from "react";
import Table from "../Table/Table";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { Bounce, toast } from "react-toastify";

const SediMe = () => {
  const [loading, setLoading] = useState(false);
  const [sedi, setSedi] = useState([]);
  const navigate = useNavigate();
  const [perPage] = useState(20);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole !== "OPERATOR") {
      alert("Accedi come operatore per visualizzare le sedi!");

      navigate("/login");
      localStorage.clear();
    } else {
      fetchSediMe();
    }
  }, [navigate]);

  const fetchSediMe = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/sedi/me`);
      if (response.status === 200) {
        setSedi(response.data);
        setTotalRows(response.data.length);
      } else {
        toast.error("Qualcosa è andato storto!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedSedi = sedi.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );

  const columns = [{ field: "indirizzoSede", header: "Indirizzo Sede" }];

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="page-header">
        <div className="page-title">Sedi</div>
      </div>

      <div className="page-content sedi">
        <Table
          columns={columns}
          data={paginatedSedi}
          onPageChange={handlePageChange}
          totalRows={totalRows}
          perPage={perPage}
          currentPage={currentPage}
        />
      </div>
    </div>
  );
};

export default SediMe;
